import { css } from 'linaria';
import { styled } from 'linaria/react';
import { Photo } from 'model/domain';
import { sendEvent } from 'model/helpers/events.model';
import { uploadPhotoFx } from 'model/flows/verification.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { version } from '../../../../package.json';

import { Button } from 'ui/atoms/button';
import { Camera } from 'ui/camera';
import { InfoIcon } from 'ui/icons/info-icon';
import { OnboardLayout } from 'features/verify/ui/onboard-layout';
import { ButtonContainer } from 'features/verify/ui/button-container';

export const Selfie = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());

	const CameraComponent = Camera;

	useEffect(() => {
		screenHistoryPush(ScreenName.selfie_instructions);
		setTimeout(() => {
			sendEvent({ event: 'selfie_instructions_screen_shown' });
		}, 20)
	}, []);
	const handleUpload = async (photo: Photo) => {
		const t0 = performance.now();
		await uploadPhotoFx({ photo });
		const upload_time = Math.round(performance.now() - t0);
		sendEvent({
			event: 'selfie_upload_success',
			event_attributes: { upload_time },
		});
	};
	const handleContinue = () => {
		sendEvent({
			event: 'selfie_instructions_screen_continue',
			event_attributes: {
				duration: Date.now() - start,
			},
		});
	};

	return (
		<OnboardLayout
			title={t('mobile.selfie.title')}
			subtitle={t('mobile.selfie.subtitle')}
			info={[{
				icon: <InfoIcon
					fill={'var(--text-tertiary)'}
				/>,
				text: <Fragment>
					{t('mobile.selfie.instructions')}
				</Fragment>,
			}]}
		>
			<ButtonContainer>
				<ImageContainer>
					<img src={`https://cdn.hive.id/verify-js/${version}/images/selfie.svg`} alt=""/>
				</ImageContainer>
				<CameraComponent
					cameraType={'front'}
					onCapture={handleUpload}
				>
					<Button
						name={'mobile.selfie.btn'}
						className={fluidClass}
						onClick={handleContinue}
					>
						{t('mobile.selfie.btn')}
					</Button>
				</CameraComponent>
			</ButtonContainer>
		</OnboardLayout>
	);
};

const fluidClass = css`
	width: 100%;
`;
const ImageContainer = styled('div')`
	margin: 16px auto auto;

  @media (max-height: 500px) {
    display: none;
  }
`;
